import React from "react";

const ProgressBar = ({ bgcolor, completed }) => {

    const containerStyles = {
        height: 14,
        width: '100%',
        backgroundColor: "#e0e0de",
        borderRadius: 50,
        margin: 25
    }

    const fillerStyles = {
        height: '100%',
        width: `${completed}%`,
        backgroundColor: bgcolor,
        borderRadius: 'inherit',
        textAlign: 'right',
        transition: 'width 1s ease-in-out',
    }

    const labelStyles = {
        padding: 4,
        fontSize: '0.7rem',
        color: 'white',
        fontWeight: 'bold'
    }

    return (
        <div style={containerStyles}>
            <div style={fillerStyles}>
                <span style={labelStyles}>
                    {(completed && typeof completed==='number')
                        ?`${Math.round(completed)}%`:null
                    }</span>
            </div>
        </div>
    );

};

export default ProgressBar;
